/* es6-symbol/index */ function _(require, module, exports) {
    module.exports = require(367) /* ./is-implemented */() ? Symbol : require(369) /* ./polyfill */;
}
